export function arrayBufferToBase64Utf8(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer))); //.toString("utf8")
}

export async function fileToInlineDataPart(file) {
  const buf = await file.arrayBuffer();
  const b64 = arrayBufferToBase64Utf8(buf);

  return {
    inline_data: {
      data: b64, // base64 of file bytes
      display_name: (file.type === "text/csv"
        ? file.name || "file.csv"
        : toTxtName(file.name)
      ).replace(/\s+/g, ""), //remove space
      mime_type: file.type === "text/csv" ? "text/csv" : "text/plain",
    },
  };
}

const toTxtName = (name = "file") => {
  const i = name.lastIndexOf(".");
  const base = i > -1 ? name.slice(0, i) : name;
  return `${base}.txt`;
};

export function fileToFileDataPart(file, gsUri) {
  return {
    file_data: {
      display_name: file.name.replace(/\s+/g, ""),
      file_uri: gsUri,
      mime_type: file.type === "text/csv" ? "text/csv" : "text/plain",
    },
  };
}

// Helper for multiple files
export async function filesToInlineParts(files = []) {
  const arr = Array.from(files);
  const parts = arr.filter(
    (f) =>
      f.type === "application/json" ||
      f.type === "text/csv" ||
      f.name.toLowerCase().endsWith(".csv") ||
      f.type === "" // some browsers leave type empty
  );

  return Promise.all(parts.map(fileToInlineDataPart));
}
